import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
const useFilterAggregationValues = ({
  data,
  filterValues
}) => {
  const [stateValues, setStateValues] = useState(data);
  const [prop, setProp] = useState('');
  useEffect(() => {
    if (!stateValues) return setStateValues(data);
    const lastChangedFilter = filterValues === null || filterValues === void 0 ? void 0 : filterValues[prop];
    if (!data) return;
    const newOptions = data[prop];
    const currentOptions = stateValues === null || stateValues === void 0 ? void 0 : stateValues[prop];
    if (lastChangedFilter === null || lastChangedFilter === '') {
      return setStateValues(prevState => _objectSpread(_objectSpread({}, data), {}, {
        [prop]: newOptions
      }));
    }
    setStateValues(prevState => _objectSpread(_objectSpread({}, data), {}, {
      [prop]: currentOptions
    }));
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [data, prop, filterValues]);
  return [stateValues, setStateValues, setProp, prop];
};
export default useFilterAggregationValues;
//# sourceMappingURL=use-filter-aggregation-values.js.map